/* eslint-disable @typescript-eslint/no-explicit-any */
import { boot } from 'quasar/wrappers'
import izi from 'src/modules/izitoast'

export default boot(({ app }) => {
  app.config.globalProperties.$toast = izi
})
